import service from '@/store/services/settings/activity-laboure-workplace-service';

const state = {
    list: {},
    activityLabourerWorkplace: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activityLabourerWorkplace) => {
        state.activityLabourerWorkplace = activityLabourerWorkplace;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activityLabourerWorkplace => {
                commit('SET_RESOURCE', activityLabourerWorkplace);
            });
    },
    view ({ commit, dispatch }, params) {
        return service.view(params)
            .then(activityLabourerWorkplace => {
                commit('SET_RESOURCE', activityLabourerWorkplace);
            });
    },

    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activityLabourerWorkplace => {
                commit('SET_RESOURCE', activityLabourerWorkplace);
            });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((activityLabourerWorkplace) => {
                commit('SET_RESOURCE', activityLabourerWorkplace);
                return activityLabourerWorkplace;
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activityLabourerWorkplace) => {
                commit('SET_RESOURCE', activityLabourerWorkplace);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activityLabourerWorkplace: state => state.activityLabourerWorkplace,
    dropdown: (state) => {
        return state.list.map(activityLabourerWorkplace => ({
            id: activityLabourerWorkplace.id,
            name: activityLabourerWorkplace.request_type
        }));
    },
    url: state => state.url,
};

const activityLabourerWorkplaces = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activityLabourerWorkplaces;
